/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';
import type { InternalApiTransaction } from './InternalApiTransaction';
import {
    InternalApiTransactionFromJSON,
    InternalApiTransactionFromJSONTyped,
    InternalApiTransactionToJSON,
    InternalApiTransactionToJSONTyped,
} from './InternalApiTransaction';

/**
 * 
 * @export
 * @interface InternalApiCaseTransaction
 */
export interface InternalApiCaseTransaction {
    /**
     * 
     * @type {InternalApiTransaction}
     * @memberof InternalApiCaseTransaction
     */
    transaction: InternalApiTransaction;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCaseTransaction
     */
    createdAt: Date;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiCaseTransaction
     */
    createdBy: InternalApiUserBasicDetails;
}

/**
 * Check if a given object implements the InternalApiCaseTransaction interface.
 */
export function instanceOfInternalApiCaseTransaction(value: object): value is InternalApiCaseTransaction {
    if (!('transaction' in value) || value['transaction'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    return true;
}

export function InternalApiCaseTransactionFromJSON(json: any): InternalApiCaseTransaction {
    return InternalApiCaseTransactionFromJSONTyped(json, false);
}

export function InternalApiCaseTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'transaction': InternalApiTransactionFromJSON(json['transaction']),
        'createdAt': (new Date(json['createdAt'])),
        'createdBy': InternalApiUserBasicDetailsFromJSON(json['createdBy']),
    };
}

export function InternalApiCaseTransactionToJSON(json: any): InternalApiCaseTransaction {
    return InternalApiCaseTransactionToJSONTyped(json, false);
}

export function InternalApiCaseTransactionToJSONTyped(value?: InternalApiCaseTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transaction': InternalApiTransactionToJSON(value['transaction']),
        'createdAt': value['createdAt'].toISOString(),
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
    };
}

